import { Dayjs } from 'dayjs';

import { assignSafe, SDate } from '@summit/core';
import { FilterParameter } from '@summit/models';

export class CrudCacheParameters {
  isLoading: boolean;
  freshnessDate: Dayjs;
  addedIds: string[] = Array<string>();
  removedIds: string[] = Array<string>();
  modifiedIds: string[] = Array<string>();
  filterParameters: FilterParameter[];

  constructor(jsonData?: Partial<CrudCacheParameters>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.freshnessDate) {
        this.freshnessDate = SDate.new(jsonData.freshnessDate);
      }
    }
  }
}
